/**
 * Returns a formatted PHP Curreny based from a number
 *
 * @param {number} num Number to be formatted
 */
export const formatPHPCurrency = (num = 0) => `₱${num.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;
